import moment from 'moment';
import  { DATE_DISPLAY_FORMAT } from '../constants';

/**
 * Validate a string as a date
 *
 * @param {string} input - value being tested
 * @param {momentObject} lowerLimit - Date can't be before this date to be valid
 * @param {momentObject} upperLimit - Date can't be after this date to be valid
 * @returns {object}
 */
export default function DateValidator({ input, lowerLimit, upperLimit }) {
    const parsed = {
        isValid: false,
        isValidMoment: false,
        moment: null,
        formattedValue: null,
        errorMessage: null
    };
    
    if (typeof input === 'string' && input.length) {
        parsed.moment = moment(input, [
            'MM-DD-YYYY',
            'M-D-YY'
        ]);
        
        if (parsed.moment.isValid()) {
            parsed.isValidMoment = true;
            parsed.formattedValue = parsed.moment.format(DATE_DISPLAY_FORMAT);
            // Assume it's valid for now; will negate if out of range later
            parsed.isValid = true;
            
            // check if is in range
            if (lowerLimit) {
                const lowerLimitMinus1 = lowerLimit.clone().subtract(1, 'days');
                const isAfterLower = parsed.moment.isAfter(lowerLimitMinus1);
                if (!isAfterLower) {
                    parsed.isValid = false;
                    parsed.errorMessage = `must be after ${lowerLimitMinus1.format(DATE_DISPLAY_FORMAT)}.`
                }
            }
            if (upperLimit) {
                const isBeforeUpper = parsed.moment.isBefore(upperLimit);
                if (!isBeforeUpper) {
                    parsed.isValid = false;
                    parsed.errorMessage = `must be before ${upperLimit.format(DATE_DISPLAY_FORMAT)}.`
                }
            }
        }
        else {
            // moment couldn't parse the date
            parsed.errorMessage = 'is invalid.';
            return parsed;
        }
        
        return parsed;
    }
}